export default __webpack_public_path__ + "static/media/RunHorseLight_6_2.0c2142dd.jpg";